import { render, staticRenderFns } from "./client-unit-enterals.vue?vue&type=template&id=80c38048&scoped=true&lang=pug&"
import script from "./client-unit-enterals.vue?vue&type=script&lang=ts&"
export * from "./client-unit-enterals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c38048",
  null
  
)

export default component.exports